import { useState } from 'react'
import { useAppStore } from '../stores/app-store'

export function PromptPanel() {
  const [showSystem, setShowSystem] = useState(false)
  const {
    systemPrompt, setSystemPrompt, resetSystemPrompt,
    userPrompt, setUserPrompt
  } = useAppStore()

  return (
    <div className="card prompt-panel">
      <div className="card-header">
        <span className="card-title">Prompt</span>
        <span className="kbd">Ctrl+Enter</span>
      </div>

      <div className="prompt-section">
        <button
          className="disclosure-btn"
          onClick={() => setShowSystem(!showSystem)}
        >
          <span>{showSystem ? '\u25BE' : '\u25B8'}</span>
          System Prompt
          <span className="hint">{systemPrompt.length > 0 ? '(configured)' : '(empty)'}</span>
        </button>

        {showSystem && (
          <div className="system-prompt-area">
            <textarea
              className="prompt-textarea system"
              value={systemPrompt}
              onChange={(e) => setSystemPrompt(e.target.value)}
              placeholder="System prompt for agent behavior..."
              rows={6}
            />
            <div style={{ marginTop: 4 }}>
              <button className="btn-small" onClick={resetSystemPrompt}>
                Reset Default
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="prompt-section">
        <label className="prompt-label">User Prompt</label>
        <textarea
          className="prompt-textarea user"
          value={userPrompt}
          onChange={(e) => setUserPrompt(e.target.value)}
          placeholder="Describe what you want to build..."
          rows={5}
          autoFocus
        />
      </div>
    </div>
  )
}
